import {
  any, boolean, date, nullable,
  object, string, number,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateUserMask = {
  acceptsCookies: boolean | nullable,
  acceptsGDPR: boolean,
  acceptsTos: boolean,
  cachedSelectedProfileId: string | nullable,
  cachedSelectedProfileType: string | nullable,
  city: string | nullable,
  country: string | nullable,
  createdAt: date,
  displayName: string | nullable,
  email: string | nullable,
  emailVerified: boolean,
  emailLinkPreferred: boolean,
  googleAnalyticsClientId: string | nullable,
  originalEmailAddress: string | nullable,
  hasIntercom: boolean,
  intent: string | nullable,
  intercomHash: string | nullable,
  isArchived: boolean,
  lastIpAddress: string | nullable,
  lastLatLng: any | nullable,
  latLng: any | nullable,
  locale: string | nullable,
  locationHash: string | nullable,
  mutedUsers: any,
  notifications: object,
  phoneNumber: string | nullable,
  providerData: any,
  pushTokens: any,
  region: string | nullable,
  selectedProfileId: string | nullable,
  selectedProfileType: string | nullable,
  updatedAt: date,
  lastOnlineAt: date,
  taxRate: number,
  taxIncluded: boolean,
};
